import {
    Button,
    Checkbox,
    CircularProgress,
    Grid,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { get, orderBy, set } from "lodash";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import BSInput from "../../../common/js/components/BSInput";
import StatusChip from "../../../common/js/components/StatusChip";
import { Play, Search, Sorty } from "../../../common/js/icons";
import "../../styles/voucherDashboard.css";
import { aggregateBrokerNames } from "../utils/operations";
import schema from "./voucherTables";

const StyledTab = styled(Tab)(() => ({
    textTransform: "none",
}));

const StyledPageToolbar = styled(Grid)(() => ({
    marginBottom: "20px",
    marginTop: "20px",
}));

const StyledListingIdLink = styled("span")({
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
    },
    color: "#2C99D2",
    fontWeight: 600,
});

const StyledAlternateContent = styled("div")({
    margin: "auto",
    textAlign: "center",
    marginTop: "4em",
    marginBottom: "1em",
});

const StyledTooltipStyled = styled("span")({
    "&>a:hover": {
        cursor: "pointer",
    },
});

const StyledProcessLink = styled("span")({
    "&:hover": {
        cursor: "pointer",
        color: "#2C99D2",
    },
    color: "#595959",
    textDecoration: "underline",
});

const StyledUndoProcess = styled("span")({
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
    },
    color: "#595959",
    fontSize: "80%",
    marginLeft: "3px",
});

const StyledSortable = styled("span")({
    paddingRight: "5px",
    paddingBottom: "3px",
});

const StyledApplyFilterButton = styled(Button)({
    marginRight: "10px",
    marginLeft: "0px",
});

const StyledDateFilterSelector = styled(Grid)({
    flexGrow: "inherit",
    width: "11em",
    marginBottom: "25x",
    marginLeft: "5px",
    marginRight: "5px",
});

const StyledCheckboxCell = styled(TableCell)({
    paddingLeft: "0px",
});

const AccountingVouchers = (props) => {
    const {
        accountingBatchViewInputParams,
        columnToSort,
        elementsSaving,
        errors,
        filterQuery,
        generateBatch,
        handleApplyDateRangeFilter,
        handleChangeAccountingInputParam,
        handleCheckboxClick,
        handleFilter,
        handleSelectAll,
        handleSort,
        history,
        isLoading,
        reopenVouchers,
        selectedVouchers,
        sortDirection,
        switchVoucherView,
        togglePrintedBy,
        toggleProcessedBy,
        userProfile,
        vouchers,
        voucherView,
    } = props;

    let voucherz = get(vouchers, voucherView, []);
    const selected = get(selectedVouchers, voucherView, []);
    const selectedSet = new Set(selected);
    const sortFunction = get(
        get(schema, `viewHeaders.${voucherView}`).find((x) => x.prop === columnToSort),
        "sortFunction"
    );

    if (sortFunction && voucherz) {
        voucherz = voucherz.map((voucher) => {
            set(voucher, columnToSort, sortFunction(get(voucher, columnToSort)));
            return voucher;
        });
    }

    const data = orderBy(
        filterQuery ? voucherz.filter((x) => schema.filterByQuery(x, schema.columnsToQuery, filterQuery)) : voucherz,
        [
            (v) => {
                return get(v, columnToSort) || "";
            },
        ],
        sortDirection
    );

    return (
        <div>
            <StyledPageToolbar container justifyContent="space-between" alignItems="center" spacing={16}>
                <Grid item>
                    <h2 className="page-title">Vouchers</h2>
                    <p className="page-subtitle">
                        Showing {voucherz ? voucherz.length : 0}{" "}
                        {!voucherz || voucherz.length > 1 || voucherz.length === 0 ? "vouchers" : "voucher"}
                    </p>
                </Grid>
                <Grid item>
                    {voucherView === "accounting_ready_payment" && (
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={userProfile.role !== "accounting"}
                            onClick={generateBatch}
                        >
                            <Play fill="#ffffff" />
                            Generate Batch Report
                        </Button>
                    )}
                    {voucherView === "accounting_closed" && (
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={userProfile.role !== "accounting"}
                            onClick={reopenVouchers}
                        >
                            Un-batch Selected Vouchers
                        </Button>
                    )}
                </Grid>
            </StyledPageToolbar>
            <div style={{ display: "flex" }}>
                <div style={{ flex: "1 1 auto" }}>
                    <div className="simPaper">
                        <Grid container justifyContent="space-between" alignItems="center" spacing={0}>
                            <Grid item>
                                <Tabs value={voucherView} onChange={switchVoucherView}>
                                    <StyledTab value="accounting_awaiting_payment" label="Awaiting Payment" />
                                    <StyledTab value="accounting_ready_payment" label="Ready For Payment" />
                                    <StyledTab value="accounting_closed" label="Batched Vouchers" />
                                </Tabs>
                            </Grid>
                            {voucherView === "accounting_closed" && (
                                <React.Fragment>
                                    <Grid item>
                                        <Grid container alignItems="center" spacing={0} justifyContent="flex-end">
                                            <Grid item align="center">
                                                <div style={{ color: "grey" }}>Start / End Date: </div>
                                            </Grid>
                                            <StyledDateFilterSelector item>
                                                <BSInput
                                                    id="startDate"
                                                    type={"date"}
                                                    value={get(accountingBatchViewInputParams, "startDate")}
                                                    errorText={get(errors, `startDate`, null)}
                                                    error={get(errors, `startDate`, null)}
                                                    onChange={handleChangeAccountingInputParam}
                                                    placeholder="Start Date"
                                                />
                                            </StyledDateFilterSelector>
                                            <Grid item align="center">
                                                <div style={{ color: "grey" }}>&mdash;</div>
                                            </Grid>
                                            <StyledDateFilterSelector item>
                                                <BSInput
                                                    id="endDate"
                                                    errorText={get(errors, `endDate`, null)}
                                                    type={"date"}
                                                    value={get(accountingBatchViewInputParams, "endDate")}
                                                    error={get(errors, `endDate`, null)}
                                                    onChange={handleChangeAccountingInputParam}
                                                    placeholder="End Date"
                                                />
                                            </StyledDateFilterSelector>
                                            <Grid item>
                                                <StyledApplyFilterButton
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleApplyDateRangeFilter}
                                                >
                                                    Apply Filter
                                                </StyledApplyFilterButton>
                                            </Grid>
                                            <Grid item>
                                                <BSInput
                                                    value={filterQuery}
                                                    placeholder="Search vouchers"
                                                    startAdornment={<Search />}
                                                    onChange={(event) => {
                                                        handleFilter(event.target.value);
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </React.Fragment>
                            )}
                        </Grid>
                        <Grid container spacing={0}>
                            <Grid style={{ flex: "1 1 auto" }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {voucherView !== "accounting_awaiting_payment" && (
                                                <StyledCheckboxCell>
                                                    <Checkbox
                                                        indeterminate={
                                                            selected.length > 0 && selected.length < voucherz.length
                                                        }
                                                        checked={selected.length === voucherz.length}
                                                        value={selected.length === voucherz.length}
                                                        onChange={(e) => handleSelectAll(e, voucherView)}
                                                        color="primary"
                                                    />
                                                </StyledCheckboxCell>
                                            )}
                                            {schema.viewHeaders[voucherView].map((x, i) => (
                                                <TableCell align={x.numeric ? "right" : "left"} key={`thc-${i}`}>
                                                    <div
                                                        style={{
                                                            alignItems: "center",
                                                        }}
                                                        onClick={() => handleSort(x.sort ? x.sort : x.prop)}
                                                    >
                                                        <div style={{ display: "inline-block" }}>
                                                            <StyledSortable>{x.name}</StyledSortable>
                                                            {x.name && (
                                                                <div style={{ display: "inline-block" }}>
                                                                    <Sorty />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!elementsSaving[voucherView] &&
                                            data.map((x, index) =>
                                                row(
                                                    x,
                                                    index,
                                                    selectedSet,
                                                    isLoading,
                                                    voucherView,
                                                    handleCheckboxClick,
                                                    toggleProcessedBy,
                                                    elementsSaving,
                                                    togglePrintedBy,
                                                    history
                                                )
                                            )}
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                        {elementsSaving[voucherView] ? (
                            <StyledAlternateContent>
                                <CircularProgress color="primary" />
                            </StyledAlternateContent>
                        ) : data.length > 0 ? null : (
                            <StyledAlternateContent>Nothing to show.</StyledAlternateContent>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const row = (
    x,
    index,
    selectedSet,
    isLoading,
    voucherView,
    handleCheckboxClick,
    toggleProcessedBy,
    elementsSaving,
    togglePrintedBy,
    history
) => {
    return isLoading ? null : (
        <TableRow key={`tr-${index}`} selectable="false">
            {voucherView !== "accounting_awaiting_payment" && (
                <StyledCheckboxCell>
                    <Checkbox
                        id={`ch-${index}`}
                        checked={selectedSet.has(x.voucherKey)}
                        onChange={() => handleCheckboxClick(voucherView, get(x, "voucherKey"))}
                        color="primary"
                    />
                </StyledCheckboxCell>
            )}
            {schema.viewHeaders[voucherView].map((y, k) =>
                y.name === "Deal" ? (
                    <TableCell key={`trc-${k}`}>
                        <StyledListingIdLink
                            onClick={() => determineRedirectRoute(x, history)}
                            data-testid="dealNameAndAddress"
                        >
                            {get(x, "dealKey")}{" "}
                            {get(x, "listingName", null) !== null
                                ? ` | ${get(x, "listingName")}`
                                : get(x, "consultingDealName", null) !== null
                                ? ` | ${get(x, "consultingDealName")}`
                                : ""}
                        </StyledListingIdLink>
                        <div>{get(x, "address1")}</div>
                    </TableCell>
                ) : y.prop === "voucherKey" ? (
                    <TableCell key={`trc-${k}`}>
                        <Link to={`/voucher/${get(x, y.prop)}`} style={{ textDecoration: "none" }}>
                            <StyledListingIdLink>{get(x, y.prop)}</StyledListingIdLink>
                        </Link>
                    </TableCell>
                ) : y.prop === "brokers" && !elementsSaving[voucherView] ? (
                    <TableCell key={`trc-${k}`}>
                        <Tooltip id={`accounting-voucher-tooltip-${k}`} placement="top" title={x?.brokers?.join(", ")}>
                            <StyledTooltipStyled data-tooltip-id={`accounting-voucher-tooltip-${k}`}>
                                {aggregateBrokerNames(x?.brokers)}
                            </StyledTooltipStyled>
                        </Tooltip>
                    </TableCell>
                ) : y.name === "Processed By" ? (
                    <TableCell style={{ textAlign: "left" }} key={`trc-${k}`} data-testid="processVoucherText">
                        {get(x, y.prop) ? (
                            <React.Fragment>
                                <div style={{ fontWeight: 600 }}>{get(x, y.prop)}</div>
                                <span>{moment(get(x, "acceptedDate")).format("M-D-YYYY h:mm a")}</span>
                                <StyledUndoProcess
                                    onClick={() => toggleProcessedBy(true, get(x, "voucherKey"), voucherView)}
                                >
                                    (undo)
                                </StyledUndoProcess>
                            </React.Fragment>
                        ) : (
                            <StyledProcessLink
                                onClick={() => toggleProcessedBy(false, get(x, "voucherKey"), voucherView)}
                            >
                                Process
                            </StyledProcessLink>
                        )}
                    </TableCell>
                ) : y.name === "Printed By" ? (
                    <TableCell style={{ textAlign: "left" }} key={`trc-${k}`}>
                        {get(x, y.prop) ? (
                            <React.Fragment>
                                <div>Printed by {get(x, y.prop)}</div>
                                <StyledUndoProcess
                                    onClick={() => togglePrintedBy(true, get(x, "voucherKey"), voucherView)}
                                    data-testid="printVoucherText"
                                >
                                    (undo)
                                </StyledUndoProcess>
                            </React.Fragment>
                        ) : (
                            <StyledProcessLink
                                onClick={() => togglePrintedBy(false, get(x, "voucherKey"), voucherView)}
                                data-testid="printVoucherText"
                            >
                                Print
                            </StyledProcessLink>
                        )}
                    </TableCell>
                ) : y.transform ? (
                    <TableCell key={`trc-${k}`} align={y.numeric ? "right" : "left"}>
                        {y.transform(get(x, y.prop))}
                    </TableCell>
                ) : y.prop === "voucherStatus" ? (
                    <TableCell>
                        <StatusChip status={get(x, y.prop)} />
                    </TableCell>
                ) : (
                    <TableCell key={`trc-${k}`} align={y.numeric ? "right" : "left"}>
                        {get(x, y.prop)}
                    </TableCell>
                )
            )}
        </TableRow>
    );
};

const determineRedirectRoute = (voucher, history) => {
    if (voucher.transactionType === "Consulting" && voucher.voucherKey) {
        history.push(`/voucher/${voucher.voucherKey}`);
    } else {
        history.push(`/deal/${voucher.dealKey}`);
    }
};

export default AccountingVouchers;
